import { IconButton } from "@mui/material";
import { ReportIcon } from "../../Components/Icon/ReportIcon";
import * as React from "react";

export function ReportIconButton({
    onReportButtonClick,
}: {
    onReportButtonClick: () => void;
}) {
    return (
        <IconButton disableRipple onClick={onReportButtonClick}>
            <ReportIcon
                width={"16px"}
                height={"16px"}
                color={"var(--community-color-primary-text)"}
            />
        </IconButton>
    );
}
